import { render, staticRenderFns } from "./AssignmentProgressIndicator.vue?vue&type=template&id=0b4bbe1d&scoped=true&"
import script from "./AssignmentProgressIndicator.vue?vue&type=script&lang=js&"
export * from "./AssignmentProgressIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentProgressIndicator.vue?vue&type=style&index=0&id=0b4bbe1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4bbe1d",
  null
  
)

export default component.exports